<template>
  <div>
    <div class="readable_content">
      <h1>Page Not Found!</h1>
      <p>Sorry, we couldn't find the page at this address.</p>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'Page Not Found',
    meta: [
      {
        vmid: 'robots',
        name: 'robots',
        content: 'noindex,nofollow',
      },
    ],
  },
  name: 'PageNotFound',
};
</script>

<style lang="scss" scoped></style>
